module.exports = __webpack_public_path__ + "img/4.fe95f9a3.jpg";